import {Row, Col, Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock} from '@fortawesome/pro-light-svg-icons';
import {useNavigate} from 'react-router-dom';

// Placeholder copy - swap in final verbiage. Kept minimal/non-alarming since
// this is an expected permission boundary, not an error state. Styled to
// match the existing NotFound component's centered layout pattern.
export const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="h-100 d-flex align-items-center justify-content-center not-found-container">
      <Row>
        <Col className="text-center">
          <FontAwesomeIcon icon={faLock} size="2x" fixedWidth className="mb-3" />
          <h1>Access Restricted</h1>
          <p>You don&apos;t have permission to view this page.</p>
          <Button variant="outline-dark" onClick={() => navigate('/')}>
            Return to Dashboard
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Unauthorized;
